import React from 'react'

import { useScreen } from '@hozana/screen/useScreen'
import { QA } from '@hozana/tests/constants'

import { Button } from 'elements/button/Button'
import { Div } from 'elements/layout/Div'

import { ShareSocial } from 'modules/share/components/ShareSocial'
import { SHARE_TYPES, getSocialShareIcon } from 'modules/share/constants'

export type TBigShareButtonProps = { medium: SHARE_TYPES.FACEBOOK | SHARE_TYPES.WHATSAPP }

const getMediumDarkColor = (medium: TBigShareButtonProps['medium']): `${TBigShareButtonProps['medium']}Dark` =>
  `${medium}Dark`

export const BigShareButton: TFCC<TBigShareButtonProps> = ({ medium, children }) => {
  const { xs } = useScreen()

  return (
    <Div m={{ xs: '0', sm: '20px 10px 10px', md: '20px 0 10px' }}>
      <ShareSocial shareTypes={[medium]}>
        <Button
          icon={getSocialShareIcon(medium)}
          color="white"
          bg={medium}
          hoverBg={getMediumDarkColor(medium)}
          hoverColor="white"
          borderColor={medium}
          hoverBorderColor={getMediumDarkColor(medium)}
          size="bigger"
          w="100%"
          borderRadius={xs ? 'small' : undefined}
          data-testid={QA.PUBLICATION_COMMON.BIG_SHARE_BUTTON}
        >
          {children}
        </Button>
      </ShareSocial>
    </Div>
  )
}
